import { useContext, useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { FormStepContext } from './FormStepContext';
import { fetchReferenceData } from '../../redux/slices/referencesSlice';
import ButtonBack from '../form-buttons/ButtonBack';
import ButtonNext from '../form-buttons/ButtonNext';

const ThirdStep = () => {
  const { currentStep, register, watch, setProjectDomain } =
    useContext(FormStepContext);
  const { domains } = useSelector((s) => s.references);
  const dispatch = useDispatch();
  const watchedDomain = watch('domain');
  const textInputContainerRef = useRef(null);
  const [domainsList, setDomainsList] = useState([]);
  const [isVisibleTextarea, setVisibleTextarea] = useState(false);
  const [currentNumber, setCurrentNumber] = useState(0);
  const maxLength = 100;

  useEffect(() => {
    if (domains.length === 0) dispatch(fetchReferenceData());
  }, [domains]);

  useEffect(() => {
    if (domains.length > 0 && domainsList.length === 0) setDomainsList(domains);
  }, [domains, domainsList]);

  useEffect(() => {
    setProjectDomain(watchedDomain);
  }, [watchedDomain, setProjectDomain]);

  useEffect(() => {
    if (textInputContainerRef.current) {
      textInputContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isVisibleTextarea]);

  const handleAddTextarea = (e) => {
    const itemName = e.target.dataset.name;

    if (itemName === 'Other') {
      setVisibleTextarea(true);
    } else setVisibleTextarea(false);
  };

  const countCharacters = (e) => {
    const currentLength = e.target.value.length;
    setCurrentNumber(currentLength);
  };

  return (
    <>
      <div className="laForm__stage-item__sticky-header">
        <div className="laForm__stage-badge">Stage {currentStep.id}</div>
        <h2>
          Type <strong>of domain</strong>
        </h2>
      </div>
      <div className="laForm__stage-item__wrapper">
        <fieldset className="tale-fieldset">
          <legend>What domain is this product in?</legend>

          {domainsList.length > 0 &&
            domainsList.map((item) => (
              <div key={item._id} className="tale-btn-group s-size">
                <input
                  type="radio"
                  id={item._id}
                  value={item._id}
                  data-name={item.name}
                  className="hidden-input"
                  {...register('domain', { onChange: handleAddTextarea })}
                />
                <label htmlFor={item._id} className="ic-check">
                  <div data-name={item.name} />
                  <span>{item.name}</span>
                </label>
              </div>
            ))}
        </fieldset>

        {isVisibleTextarea && (
          <div className="textarea-group pt" ref={textInputContainerRef}>
            <label>Please provide description</label>
            <input
              type="text"
              placeholder="I want to build booking app ..."
              maxLength={maxLength}
              className="input-w-counter"
              {...register('domain_other', { onChange: countCharacters })}
            />
            <div className="input-counter">
              {currentNumber}/{maxLength}
            </div>
          </div>
        )}
      </div>
      <div className="laForm__stage-item__btns">
        <ButtonBack stepId={currentStep.id} />
        <ButtonNext
          stepId={currentStep.id}
          isDisabled={!watchedDomain}
          buttonId={`${currentStep.id}-type-of-domain`}
        />
      </div>
    </>
  );
};

export default ThirdStep;

ThirdStep.propTypes = {
  currentStep: PropTypes.object,
  setProjectDomain: PropTypes.func,
  domains: PropTypes.array.isRequired,
};
